var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass:
            "h-5 w-5 text-primary-500 hover:text-primary-600 focus:text-primary-600 focus:outline-none",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.modalShown = true
            },
          },
        },
        [_c("PencilIcon")],
        1
      ),
      _vm.modalShown
        ? _c("ProjectDocumentAccessScopeModal", {
            attrs: {
              documentId: _vm.documentId,
              fileName: _vm.fileName,
              documentExtension: _vm.documentExtension,
              projectId: _vm.projectId,
            },
            on: {
              accessScopeUpdated: _vm.onAccessScopeUpdate,
              close: function ($event) {
                return _vm.hideModal()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }